import { domainConfigValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { reactChildrenValidator } from '../../../validators/react-children';
import { defaultOccAccessibilityText, occAccessibilityTextValidator } from './accessibility-text';
import { defaultOccAssets, occAssetsValidator } from './assets';
import { defaultOccConfig, occConfigValidator } from './config/config';
import { defaultOccDisplayText, occDisplayTextValidator } from './display-text/display-text';
import { defaultOccPlaceholderAssets, occPlaceholderAssetsValidator } from './placeholder-assets';
import { defaultOccSubcomponents, occSubcomponentsValidator } from './subcomponents';
const occContextPropsBaseValidatorSchema = {
    accessibilityText: occAccessibilityTextValidator,
    assets: occAssetsValidator,
    config: occConfigValidator,
    displayText: occDisplayTextValidator,
    placeholderAssets: occPlaceholderAssetsValidator,
    subcomponents: occSubcomponentsValidator,
    children: reactChildrenValidator
};
const occContextPropsWithDomainConfigValidator = Validator.object(Object.assign(Object.assign({}, occContextPropsBaseValidatorSchema), { domain: domainConfigValidator }));
const occContextPropsWithoutDomainConfigValidator = Validator.object(Object.assign(Object.assign({}, occContextPropsBaseValidatorSchema), { excludeDomainConfig: Validator.isEqualTo(true), domain: Validator.isEqualTo(undefined) }));
export const defaultOccContextProps = {
    domain: undefined,
    accessibilityText: defaultOccAccessibilityText,
    assets: defaultOccAssets,
    config: defaultOccConfig,
    displayText: defaultOccDisplayText,
    placeholderAssets: defaultOccPlaceholderAssets,
    subcomponents: defaultOccSubcomponents,
    children: undefined
};
export const occContextPropsValidator = Validator.any([
    occContextPropsWithDomainConfigValidator,
    occContextPropsWithoutDomainConfigValidator
]);
//# sourceMappingURL=props.js.map